import styled from "styled-components";
import {FontSize, FontWeight, ThemesColors} from "../../themes";
import { Header } from 'antd/es/layout/layout';
import {IMood} from "../../interface";

interface  IHeaderProps{
    align:string
}


const HeaderContainer = styled(Header)<IMood>`
 background: transparent;
 margin: 0 16px;
 padding: 0 24px;
    padding-left: 0;
    margin-left: 0;
    padding-right: 0;
    margin-right: 0;
 display: flex;
    @media (max-width: 575px) {
        height: 48px;
    }
 align-items: center;
 background-color: rgb(1500, 252, 253);
`;

const InputIconWrapper = styled.div`
    display: flex;
    width: 100%;
    align-items: inherit;
gap: 23.5px;  

`

const IconsContainer = styled.div`
  display: flex;
  

  @media (max-width: 768px) {
   gap: 0px;
  }

  @media (max-width: 575px) {
   gap: 0;
      margin-top:3px !important;
  }
    @media (max-width:480px)
    {
        margin-top:7px !important;
    }
 
 `
const HeaderUserWrapper = styled.div`
 display: flex;
 gap: 10px;
 padding: 8px;
 align-items: center;

 @media (max-width: 768px) {
     gap: 5px;
     padding: 0;
 }

 @media (max-width: 480px) {
     gap: 0;
     padding: 0;
 }
`;

const HeaderUserFullNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
    
`;



const HeaderUserPosition = styled.p<IHeaderProps>`
    color: ${ThemesColors.gray500};

 text-align: ${({ align = 'right' }) => align}; 
  font-family: Inter;
  font-size: ${FontSize.mg};
  font-style: normal;
  font-weight: ${FontWeight.medium};
 color:${ThemesColors.gray500};
  line-height: normal;
 @media (max-width: 575px) {
  font-size: 12px;
     display: none !important;
 }

 @media (max-width: 480px) {
  font-size: 10px;
 }
`;


const UserImageWrapper = styled.img`
 width: 50px;
 height: 50px;
 border-radius: 50%;

 @media (max-width: 768px) {
  width: 40px;
  height: 40px;
 }

 @media (max-width: 480px) {
  width: 35px;
  height: 35px;
 }
`;


const HeaderUserInformationWrapper = styled.div`
 display: flex;
 align-items: center;
 justify-content: end;
 width: 100%;
 `

const HeaderSearchButtonWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    width: 70%;
   
    @media (max-width:575px)
    {
        display:none;
    }
`;

const HeaderIconHover = styled.img`
 width: 14px;
 height: 14px;
 color:black;   
    @media (max-width:768px)
    {
        display:none !important;
    }
`

const HeaderUserSettingContainer = styled.div`
 position: relative;
 padding: 0px 15px;
 &:hover > div {
  display: block;
 }

`

const MbOpenClick = styled.div`
  display: none;

  @media (max-width: 575px) {
    display: flex;

    div {
      border: none;
      cursor: pointer;
      font-size: 1.5rem;
      background-color: white;
      padding-left: 24px;
    }


  }
`;
export {
    HeaderUserWrapper,
    HeaderUserFullNameWrapper,
    MbOpenClick,
    HeaderUserPosition,
    UserImageWrapper,
    HeaderContainer,
    InputIconWrapper,
    HeaderSearchButtonWrapper,
    HeaderUserInformationWrapper,
    HeaderIconHover,
    HeaderUserSettingContainer,
    IconsContainer
};